import { FacebookEvents } from '@ali-saad-jaffer/capacitor-facebook-events';
import { Injectable } from '@angular/core';
import { catchError, from, of } from 'rxjs';
import { AppFeaturesService } from '../portal/app-features.service';

export enum MetaAppEvent {
  COMPLETE_REGISTRATION = 'fb_mobile_complete_registration',
  CONTENT_VIEW = 'fb_mobile_content_view',
  INITIATE_CHECKOUT = 'fb_mobile_initiated_checkout',
  PURCHASE_EVENT = 'fb_mobile_purchase',
  PAYMENT_INFO_EVENT = 'fb_mobile_add_payment_info',
}

@Injectable({
  providedIn: 'root',
})
export class MetaAppEventsService {
  constructor(private appFeaturesService: AppFeaturesService) {}

  logCompleteRegistration() {
    if (!this.appFeaturesService.isNative) {
      return of(null);
    }
    return from(
      FacebookEvents.logEvent({
        event: MetaAppEvent.COMPLETE_REGISTRATION,
        params: {
          fb_registration_method: 'manual',
        },
      })
    ).pipe(
      catchError((err) => {
        console.error(err);
        return of(null);
      })
    );
  }

  logContentView(options: { contentType: string; contentId: string }) {
    if (!this.appFeaturesService.isNative) {
      return of(null);
    }

    return from(
      FacebookEvents.logEvent({
        event: MetaAppEvent.CONTENT_VIEW,
        params: {
          fb_content_type: options.contentType,
          fb_content_id: options.contentId,
        },
      })
    ).pipe(
      catchError((err) => {
        console.error(err);
        return of(null);
      })
    );
  }

  logInitiateCheckout() {
    if (!this.appFeaturesService.isNative) {
      return of(null);
    }

    return from(
      FacebookEvents.logEvent({
        event: MetaAppEvent.INITIATE_CHECKOUT,
        params: {
          fb_currency: 'CAD',
        },
      })
    ).pipe(
      catchError((err) => {
        console.error(err);
        return of(null);
      })
    );
  }

  logPurchaseEvent(orderServiceId: string) {
    if (!this.appFeaturesService.isNative) {
      return of(null);
    }

    return from(
      FacebookEvents.logEvent({
        event: MetaAppEvent.PURCHASE_EVENT,
        params: {
          fb_currency: 'CAD',
          fb_content_id: orderServiceId,
        },
      })
    ).pipe(
      catchError((err) => {
        console.error(err);
        return of(null);
      })
    );
  }

  logPaymentInfoEvent(success: boolean) {
    if (!this.appFeaturesService.isNative) {
      return of(null);
    }

    return from(
      FacebookEvents.logEvent({
        event: MetaAppEvent.PAYMENT_INFO_EVENT,
        params: {
          fb_success: success ? '1' : '0',
        },
      })
    ).pipe(
      catchError((err) => {
        console.error(err);
        return of(null);
      })
    );
  }
}
